export function productSheetToMarkdown(sheet) {
  const v = sheet.variant || {};
  const lines = [
    `# ${v.designation || "Produkt"} · ${v.size || ""}`,
    `**RDK:** ${v.rohdichteklasse || "—"}  **DFK:** ${v.druckfestigkeitsklasse || "—"}`,
    sheet.approval_number ? `**Zulassung:** ${sheet.approval_number}` : "",
    sheet.valid_until ? `**Gültig bis:** ${sheet.valid_until}` : "",
    "",
  ];
  for (const s of sheet.sections || []) {
    lines.push(`## ${s.title || s.key}`, "");
    for (const e of s.entries || []) {
      const norm = e.norm ? ` — ${e.norm}` : "";
      const src = e.source?.location ? ` [${e.source.location}]` : "";
      const flag = e.verified === false ? " ⚠ nicht verifiziert" : "";
      lines.push(`- **${e.label}:** ${e.value ?? "—"}${norm}${src}${flag}`);
    }
    lines.push("");
  }
  return lines.filter((l) => l !== undefined).join("\n");
}

export function downloadText(filename, text, mime = "text/markdown") {
  const blob = new Blob([text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
